(function () {
  'use strict';

  function getAnswer(details, summary) {
    if (!details) return null;
    if (summary && summary.nextElementSibling && summary.nextElementSibling.matches('[data-faq-answer]')) {
      return summary.nextElementSibling;
    }
    return details.querySelector('[data-faq-answer]');
  }

  function wasOpen(details, answer) {
    return !!(
      details && (
        details.hasAttribute('open') ||
        details.classList.contains('faq__details--open') ||
        (answer && answer.dataset.animationState === 'open')
      )
    );
  }

  function answerIsVisiblyOpen(details, answer) {
    if (!details || !answer || !details.hasAttribute('open')) return false;
    if (answer.dataset.animationState === 'open') return true;

    var styles = window.getComputedStyle(answer);
    if (styles.display === 'none' || styles.visibility === 'hidden') return false;

    return answer.getBoundingClientRect().height > 0;
  }

  function clearFallbackStyles(answer) {
    if (!answer || answer.dataset.eeFaqFallbackOpen !== 'true') return;

    answer.style.removeProperty('display');
    answer.style.removeProperty('height');
    answer.style.removeProperty('opacity');
    answer.style.removeProperty('overflow');
    answer.removeAttribute('data-ee-faq-fallback-open');
  }

  function forceOpen(details, answer) {
    if (!details || !answer) return;

    details.setAttribute('open', '');
    details.classList.add('faq__details--open');
    details.classList.add('ee-faq-fallback-active');

    answer.style.display = 'block';
    answer.style.height = 'auto';
    answer.style.opacity = '1';
    answer.style.overflow = 'visible';
    answer.setAttribute('data-ee-faq-fallback-open', 'true');
  }

  function forceClosed(details, answer) {
    if (!details || !answer) return;

    details.removeAttribute('open');
    details.classList.remove('faq__details--open');
    details.classList.remove('ee-faq-fallback-active');
    clearFallbackStyles(answer);
  }

  function themeSuccessfullyClosed(details, answer) {
    if (!details || !answer) return true;

    return (
      answer.dataset.animationState === 'closed' ||
      !details.hasAttribute('open') ||
      !details.classList.contains('faq__details--open')
    );
  }

  // Capture the state before Empire's summary click handler runs. We do not
  // prevent the click; Empire gets the first opportunity to handle it normally.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var summary = target.closest('[data-faq-summary]');
    if (!summary) return;

    var details = summary.closest('[data-faq-details]');
    var answer = getAnswer(details, summary);
    if (!details || !answer) return;

    var initiallyOpen = wasOpen(details, answer);

    // Empire applies its animation state within a couple of animation frames.
    // Wait long enough to let that happen, then recover only if it did not.
    window.setTimeout(function () {
      if (!document.documentElement.contains(details)) return;

      if (initiallyOpen) {
        if (themeSuccessfullyClosed(details, answer)) {
          if (!details.hasAttribute('open')) {
            details.classList.remove('faq__details--open');
            details.classList.remove('ee-faq-fallback-active');
            clearFallbackStyles(answer);
          }
          return;
        }

        forceClosed(details, answer);
        return;
      }

      if (!answerIsVisiblyOpen(details, answer)) {
        forceOpen(details, answer);
      }
    }, 150);
  }, true);

  // Keep fallback state tidy when native <details> behavior closes an item.
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details || !details.matches || !details.matches('[data-faq-details]')) return;

    if (!details.hasAttribute('open')) {
      var answer = details.querySelector('[data-faq-answer]');
      details.classList.remove('faq__details--open');
      details.classList.remove('ee-faq-fallback-active');
      clearFallbackStyles(answer);
    }
  }, true);
})();
